import React, { useState } from "react";
import { VideoUploadAreaWrapper } from "@common/components/VideoUploadArea/VideoUploadArea.styled";
import { Flex, Icon, RkVideoPlayer, Typography, useTheme } from "@ugc-ui/lego";
import { useIsMobile } from "@common/hooks/isMobile";
import { VideoCampaignButton } from "@admin/pages/ShowCampaign/ShowCampaign.styled";
import { CampaignReviewData } from "@common/api/__generated__";
import { getVideoLink } from "@common/utils/getVideoLink";

interface Props {
  currentCampaign: CampaignReviewData;
  isShowPreviewBtn?: boolean;
}

export const VideoPlayer: React.FC<Props> = ({
  currentCampaign,
  isShowPreviewBtn,
}) => {
  const [adsInfo, setAdsInfo] = useState<boolean>(isShowPreviewBtn);
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <VideoUploadAreaWrapper data-cy="зона-видео-плеера">
      {isShowPreviewBtn && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          style={{ marginBottom: "10px" }}
        >
          <VideoCampaignButton
            theme={theme}
            onClick={() => setAdsInfo(!adsInfo)}
          >
            <Typography color={theme.gray.a80} type="body2">
              Превью
            </Typography>
            <Icon
              icon={adsInfo ? "eye-off" : "eye-on"}
              size="extraSmall"
              dataCy="кнопка показать превью"
              color={theme.gray.a40}
            />
          </VideoCampaignButton>
        </Flex>
      )}
      <RkVideoPlayer
        src={getVideoLink(currentCampaign?.videoLinks, currentCampaign.link)}
        thumbnail={currentCampaign.thumbnail}
        withThumbnail
        playIcon={
          isMobile && {
            icon: "play",
            size: "small",
            color: "#fff",
          }
        }
        isNeedControls={!isMobile}
        campaignData={{
          ...currentCampaign,
          link: currentCampaign.productLink,
        }}
        showAdsInfo={adsInfo}
      />
    </VideoUploadAreaWrapper>
  );
};
